/**
 * File: qpSummary.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
import commentsPopup from '../views/comments-popup.html'
class QpSummaryController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, CONSTANTS, qpHandler) {

        let noActvity = true
        $scope.array = []
        $scope.questionList = []
        $scope.qpStatus = false
        $scope.questionDetails = {};
        $scope.questions = [];
        $scope.score = 0
        this.viewSubmission = true
        $scope.isCreator = false
        $scope.isUserAssigned = false
        $scope.isSubmitApproval = false
        $scope.enableStartNow = false;
        $scope.activityAttended = false
        let noAuthMenuBar = localStorageService.get('noAuthMenuBar');
        //Boolean - To check whether activity password is present or not
        $scope.isActivityPassword = false
        $scope.activity_answer_sheet_view = false
        $scope.total_mark = 0
        let self = this;
        let qpId = $stateParams.qpId
        let activity_answer_sheet_view = localStorageService.get('activity_answer_sheet_view')
        let authoring = localStorageService.get('authoringData')
        // if(!authoring){
        //     authoring = localStorageService.get('activity_answer_sheet')
        // }
        if(activity_answer_sheet_view){
            $scope.activity_answer_sheet_view = true
        }
        let userId = localStorageService.get("user_id")

        if (authoring)
            $scope.class = authoring.class
        $scope.isApprover = false
        self.date = '';
        $scope.questionPaper = {};
        let qpSub = undefined;
        let TYPE_INFO = {}
        let normal_type = {
            _id : "normal",
            name : "Normal"
        }
        let activity_types = [{
            _id : "learning_outcome",
            name : "Learning Outcome"
        },{
            _id : "wrapup_test",
            name : "Wrap Up Test"
        },normal_type]
        for (let index = 0; index < activity_types.length; index++) {
            let element = activity_types[index];
            TYPE_INFO[element._id] = element
        }
        // $scope.qp_type['activity_type'] = normal_type._id
        this.$onDestroy = () => {
            if (qpSub)
                qpSub.stop()
        }
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "activityList"
        })
        $scope.activityUserPrivilege = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
    
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            authService.callAPI(activityCons.API_GET_QP_SUMMARY + "/" + qpId, "GET", undefined, function(response) {
                if (response.result != undefined) {
                    loadTemplate(response.result)
                } else {
                    console.log("error : " + response.error)
                    console.log(response.error)
                }
            })
            loadActivityStatus()
        }
        $scope.minDate = new Date()
        let loadTemplate = (resultObj) => {
            let result = undefined
            if (resultObj.data && resultObj.data && resultObj.data.data && resultObj.data.data.template) {
                result = resultObj.data.data.template

                $scope.serverDate = result.server_time
                try{
                    let date_server = new Date(result.server_time)
                    let _date = new Date(date_server.getFullYear(),
                    date_server.getMonth(),
                    date_server.getDate()
                    )
                    $scope.minDate = _date
                }catch(ed){
                    console.log(ed)
                    $scope.minDate = result.server_time
                }
                //Object - Summary details of the activity
                $scope.qpTemplatePreview = {
                    template: result
                }

                getQPDetails(1);
                $scope.$apply();
            }
        }
        $scope.addToDL = () => {
            $scope._disable_archive_add = true
            authService.callAPI("/v1/sync_to_archive/" + qpId, "GET", {}, function(response) {
                if(response && response.result && response.result.status &&
                    response.result.status.code == 200){
                        $scope._can_add_to_archive = false
                        toastr.success("Added this question paper to digital library")
                }else{
                    $scope._disable_archive_add = false
                }
                $scope.$apply();
            })
        }
        function canAddToArchive(qpDoc){
            if(qpDoc && qpDoc._can_add_to_archive){
                $scope._can_add_to_archive = true
            }
        }
        $scope._can_add_to_archive = false
        $scope._disable_archive_add = false
        let getQPDetails = (call) => {
            console.log(call)
            authService.callAPI(activityCons.API_QP_DETAILS + qpId, "GET", {}, function(response) {
                if (response.result != undefined) {
                    let result = response.result.data.details
                    if(result.academic && !$rootScope.title){
                        $rootScope.title = result.academic
                    }
                    $scope.activityId = result.activity_id
                    _.each(result.students, function(eachStud) {
                        if (eachStud._id === userId) {
                            if (eachStud.status === "not attended") {
                                // TO get activity password
                                $scope.enableStartNow = true;
                                if (result.activity_password && result.activity_password !== null && result.activity_password !== undefined && result.activity_password !== "") {
                                    $scope.activityPwd = result.activity_password
                                    $scope.isActivityPassword = true
                                }
                            }
                            $scope.studentStatus = eachStud.status
                            $scope.resultStatus = eachStud.result
                        }
                    })
                    if (result.students && result.students.length > 0)
                        $scope.isUserAssigned = true


                    $scope.isStart = false
                    $scope.isSchedule = false
                    $scope.isReschedule = false
                    $scope.isViewSubmission = false
                    $scope.isPublishResult = false
                    $scope.isPublished = false
                    $scope.isCompleted = false

                    if (result.status == "approved") {
                        $scope.isSchedule = true
                        $scope.isStart = true
                        canAddToArchive(result)
                    } else if (result.status == "scheduled") {
                        $scope.isStart = true
                        $scope.isReschedule = true
                        canAddToArchive(result)
                    } else if (result.status == "conducted") {
                        $scope.isViewSubmission = true
                        $scope.isPublishResult = true
                        $scope.isCompleted = false
                        canAddToArchive(result)
                    } else if (result.status == "published") {
                        $scope.isViewSubmission = true
                        $scope.isCompleted = true
                        $scope.isPublished = true
                        canAddToArchive(result)
                    } else if (result.status == "completed") {
                        $scope.isCompleted = true
                        $scope.isViewSubmission = true
                        $scope.isPublishResult = true
                        canAddToArchive(result)
                    } else if (result.status == "sent_for_approval") {
                        if (result.current_approver && result.current_approver._id) {
                            if (result.current_approver._id === userId)
                                $scope.isApprover = true
                        }
                    }

                    $scope.questionList = {
                        id: result.activity_id,
                        title: result.question_paper_title,
                        status: result.status,
                        isPractice: result.practice_qn,
                        approver_comment : result.approver_comment,
                        is_visibleto_parents : result.is_visibleto_parents,
                        qp_type : normal_type.name,
                        auto_wrapup : result.auto_wrapup 
                    }
                    if(result.qp_type){
                        $scope.questionList.qp_type = TYPE_INFO[result.qp_type.activity_type]['name']
                    }
                    if (result.teacher_id === userId)
                        $scope.isCreator = true
                    if ($scope.questionList.length === 0) {
                        noActvity = true
                    } else {
                        noActvity = false
                    }
                    $scope.$apply()
                } else {
                    console.log(response.error)
                }
            })
        }
        $scope.viewComment = (ev) => {
            if($scope.questionList && $scope.questionList.approver_comment){
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Approver comment')
                        .textContent($scope.questionList.approver_comment)
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                        .targetEvent(ev)
                );
            }
            
        }
        $scope.routeToQpPreview = function() {
            localStorageService.set("isViewAllQuestion", true);

            $state.go('activityPreview', {
                "qpId": qpId
            });

        }
        $scope.gotoAssigningPage = () => {
            if ($scope.isUserAssigned) {
                var confirm = $mdDialog.confirm()
                    .textContent('It will reassign previously assigned students')
                    .ok('Ok')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function() {
                    $state.go('assignStudents', {
                        qpId: $state.params.qpId,
                        previousState: {
                            state: 'qpSummary',
                            params: $stateParams
                        }
                    })
                }, function() {});
            } else {
                $state.go('assignStudents', {
                    qpId: $state.params.qpId,
                    previousState: {
                        state: 'qpSummary',
                        params: $stateParams
                    }
                })
            }
        }

        $scope.checkingChoiceExists = function(choice, data) {
            let isChecked = false;
            if (data.my_answer != undefined) {
                return data.my_answer.indexOf(choice) > -1
            } else {
                return isChecked
            }
        }
        $scope.viewMyAnswer = function(data) {
            if (data.status !== "published" && !data.isPractice) {
                alert = $mdDialog.alert({
                    textContent: 'Result is not published',
                    ok: 'Ok'
                });

                $mdDialog
                    .show(alert)
                    .finally(function() {
                        alert = undefined;
                    });
            } else {
                $state.go('studentAnswerView', {
                    qpId: qpId
                })
            }
        }

        function removeSpecialCharacter(value) {
            if (value) {
                value = value.replace(/\\quad/g, "")
                value = value.replace(/\\/g, "")
            }
            return value
        }

        /* Set answered choice is wrong or correct*/
        function setChoice() {
            _.each($scope.questions, function(section) {
                _.each(section.answers, function(data, key) {
                    $scope.total_mark += parseInt(data.mark)
                    let score = parseFloat(data.my_score)
                    $scope.score += score;
                    if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                        _.each(data.choice, function(choice) {
                            if ($scope.checkingChoiceExists(choice.desc, data)) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                }
                            }
                        })
                    } else if (data.type == 'TF') {
                        _.each(data.choice, function(choice) {
                            if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            }
                        })
                    } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                        let key = 0
                        _.each(data.answer, function(choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'OWQ') {
                        let key = 0
                        _.each(data.answer, function(choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'MTF') {
                        data.ans_key = []
                        let key = 0
                        _.each(data.option, function(choice) {
                            let correctAnswer = removeSpecialCharacter(choice.question.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let correct = false
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key].desc)
                                if (correctAnswer !== studentAnswer) {
                                    correct = false
                                } else {
                                    correct = true
                                }
                                data.ans_key.push({
                                    desc: data.my_answer[key].desc,
                                    correct: correct,
                                    optImage: data.my_answer[key].optImage
                                })
                            }
                            key++
                        })
                    } else if (data.type == 'ASLLISTEN') {
                        _.each(data.questions, function(aslListQues) {
                            if (aslListQues.type == 'mcq') {
                                _.each(aslListQues.choice, function(choice) {
                                    if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'tf') {
                                _.each(aslListQues.choice, function(choice) {
                                    if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'fib') {
                                _.each(aslListQues.answer, function(choice, index) {
                                    let correctAnswer = removeSpecialCharacter(choice.desc)
                                    if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                        let studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index])
                                        if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    } else {
                                        choice.wrong = true
                                        if (aslListQues.my_answer != undefined) {
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        } else {
                                            aslListQues.my_answer = []
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'text') {
                                let correctAnswer = removeSpecialCharacter(aslListQues.answer)
                                if (aslListQues.my_answer != undefined) {
                                    let studentAnswer = removeSpecialCharacter(aslListQues.my_answer)
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        aslListQues.wrong = true
                                    } else {
                                        aslListQues.correct = true
                                    }
                                } else {
                                    aslListQues.wrong = true
                                    aslListQues.my_answer = 'Not Answered'
                                }
                            }
                        })
                    }

                })
            })

        }

        $scope.score = $scope.score.toFixed(2)
        $scope.cancel = function() {
            $mdDialog.hide();
        };
        $scope.setFilePath = function(img) {
            let new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined
            return new_url
        }
        $scope.beautifyFIB = function(question) {
            return question.replace(/_/g, " (_______) ")
        }

        /* Formating the date value to display format*/
        $scope.getDateInFormat = function() {
                var dateFormat = $filter('date')(assignedDate, "dd-MM-yyyy")
                if (dateFormat) {
                    self.date = dateFormat;
                } else {
                    self.date = "";
                }
            }

        $scope.startTest = function(data) {


            // Object - Holds validation errors
            $scope.errors = {};

            if ($scope.activityPassword === "") {
                $scope.errors['activityPassword'] = "Please enter password";
            } else if ($scope.activityPassword !== $scope.activityPwd) {
                $scope.errors['activityPassword'] = "Please enter correct password";

            } else if ($scope.activityPassword === $scope.activityPwd) {
                $scope.isActivityPassword = false
                $state.go('studentQuestionSelection', {
                    qpId: qpId,
                    activityId: data.id
                })
            }
        }

        $scope.scheduleExam = function(dueDate) {
            $scope.qpTemplatePreview.template.date = $scope.dueDate
            var schedulExDate = $scope.dueDate;
            schedulExDate.setHours(10); 
            let obj = {
                dueDate: schedulExDate,
                qpId: qpId,
                userId: userId
            }
            authService.callAPI(activityCons.API_SCHEDULE_EXAM, "POST", obj, function(response) {
                if (response.result) {
                    toastr.success("Activity scheduled Successfully")
                } else {
                    getQPDetails()
                    console.log("error : " + response.error)
                    console.log(response.error)
                }
            })
            $scope.isScheduleDate = false;
            $scope.isSchedule = false
            $scope.isStart = true
            $scope.viewSubmission = false
        }
        $scope.conductTest = function() {

            let reqObj = {
                activity_id: $scope.activityId,
                qp_id: qpId
            }
            authService.callAPI(activityCons.API_START_EXAM, "POST", reqObj, function(response) {
                if (response.result != undefined) {
                    $scope.isScheduleDate = false;
                    $scope.isSchedule = false
                    $scope.isStart = false
                    $scope.isViewSubmission = true
                    $scope.isPublished = false
                    $scope.isPublishResult = false
                    toastr.success("Exam started successfully")
                    getQPDetails()
                } else {
                    console.log(response.error)
                }
            })
        }
        $scope.filterPerson = () => {
            let approverList = _.filter($scope.approverRoles, function(person) {
                return person._id == $scope.approverRole
            })
            // let approverList = _.filter($scope.approverRoles, function(person) {
            //     return person._id.indexOf($scope.approverRole) !== -1;
            // })
            if (approverList && approverList.length > 0)
                $scope.approverRolePersons = approverList[0].users
        }
        function showConfirmtoPublish(){
            authService.callAPI(activityCons.API_PUBLISH_RESULT + qpId + '/' + userId, "GET", {}, function(response) {
                if (response.result != undefined) {
                    toastr.success('Result published')
                    $scope.isScheduleDate = false;
                    $scope.isSchedule = false
                    $scope.isStart = false
                    $scope.isViewSubmission = true
                    $scope.isPublished = true
                    $scope.isPublishResult = false
                    getQPDetails()
                } else {
                    console.log("error : " + response.error)
                }
            })
        }
        $scope.gotoPublish = function(ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to publish the activity?')
                .textContent('Once published, all the results will be available to student(s) and their parent(s)')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Publish')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                showConfirmtoPublish()
            }, function () {
                
            });
        }
        $scope.gotoSubmissionList = function() {

            $state.go("viewSubmissionList", {
                qpId: $stateParams.qpId
            })
        }
        $scope.closeDiv = function() {
            $scope.isScheduleDate = false;
        }
        $scope.setScheduleDate = function(ev) {
            if ($scope.isUserAssigned) {
                $scope.isScheduleDate = true;
            } else {
                var confirm = $mdDialog.confirm()
                    .textContent('Please assign users')
                    .targetEvent(ev)
                    .ok('Ok')
                $mdDialog.show(confirm).then(function() {
                    $scope.isAssignUsers = true;
                }, function() {
                    $scope.isAssignUsers = false;
                });
                $scope.isPrompt = true
            }
        }
        $scope.submitforApprovalClick = () => {
            let academics = {
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id
            }
            authService.callAPI(activityCons.API_APPROVER_LIST, "POST", academics, function(response) {
                if (response.result && response.result.data && response.result.data.data) {
                    let resultData = response.result.data.data
                    if (resultData && resultData.length > 0 && resultData[0].roles)
                        $scope.approverRoles = resultData[0].roles
                    $scope.$apply()
                } else {
                    console.log(response.error)
                }
            })
            $scope.isSubmitApproval = true

        }
        $scope.cancelApproval = () => {
            $scope.isSubmitApproval = false;
        }
        $scope.submitforApproval = () => {
            if (!$scope.approverRole) {
                $scope.approverRoleError = "Select a role"
            }
            if (!$scope.approverPerson) {
                $scope.approverPersonError = "Select a person"
            }
            if ($scope.approverRole && $scope.approverPerson) {
                let approverId = $scope.approverPerson;
                $scope.isSubmitApproval = false;
                let academics = {
                    session_id: authoring.session_id,
                    curriculum_id: authoring.curriculum_id,
                    class_id: authoring.class_id,
                    batch_id: authoring.batch_id,
                    subject_id: authoring.subject_id,
                    school_id: authoring.school_id,
                    qp_id: qpId,
                    user_id: userId,
                    approver_id: approverId,
                    approver_role: $scope.approverRole
                }
                authService.callAPI(activityCons.API_SEND_FOR_APPROVAL, "POST", academics, function(response) {
                    if (response.result) {
                        toastr.success("Successfully sent for approval")
                        getQPDetails()
                    } else {
                        console.log(response.error)
                    }
                })
            }
        }
        $scope.goToActivityList = () => {
            $state.go("activityList")
        }
        $scope.approveActivity = (ev) => {
            showPopup(true)
            // var confirm = $mdDialog.prompt()
            // .title('Approve comment')
            // .textContent('Please enter the comment')
            // .placeholder('Enter reason')
            // .ariaLabel('Enter reason')
            // .initialValue('Approved')
            // .targetEvent(ev)
            // .required(true)
            // .ok('Approve')
            // .cancel('Cancel');

            // $mdDialog.show(confirm).then(function(result) {
            //     console.log(result)
            // }, function(d) {
            //     console.log(d)
            // });
            
            

        }
        $scope.approveFromPoppup = (reason) => {
            let obj = {
                qpId : qpId,
                userId : userId,
                comment : reason
            }
            authService.callAPI(activityCons.API_APPROVE_QP , "POST", obj, function(response) {
                if (response.result) {
                    toastr.success('Question paper approved successfully')
                    getQPDetails()
                } else {
                    console.log(response.error)
                }
            })
        }
        $scope.rejectFromPoppup = (reason) => {
            let obj = {
                qpId : qpId,
                userId : userId,
                comment : reason
            }
            authService.callAPI(activityCons.API_REJECT_QP, "POST", obj, function(response) {
                if (response.result) {
                    toastr.error('Question paper rejected')
                    getQPDetails()
                } else {
                    console.log(response.error)
                }
            })
        }
        function showPopup(_toApprove){
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'parentScope', '_toApprove',  approveRejectCommentsController],
                locals: {
                    _toApprove : _toApprove,
                    "parentScope" : $scope
                },
                template: commentsPopup,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                // fullscreen: useFullScreen
            })
        }
        $scope.rejectActivity = () => {
            showPopup(false)
            
        }

        function getTime(millseconds) {
            var oneSecond = 1000;
            var oneMinute = oneSecond * 60;
            var oneHour = oneMinute * 60;
            var oneDay = oneHour * 24;

            var seconds = Math.floor((millseconds % oneMinute) / oneSecond);
            var minutes = Math.floor((millseconds % oneHour) / oneMinute);
            var hours = Math.floor((millseconds % oneDay) / oneHour);
            var days = Math.floor(millseconds / oneDay);

            var timeString = '';
            if (days !== 0) {
                timeString += (days !== 1) ? (days + ' days ') : (days + ' day ');
            }
            if (hours !== 0) {
                timeString += (hours !== 1) ? (hours + ' hours ') : (hours + ' hour ');
            }
            if (minutes !== 0) {
                timeString += (minutes !== 1) ? (minutes + ' min ') : (minutes + ' min ');
            }
            if (seconds !== 0 || millseconds < 1000) {
                timeString += (seconds !== 1) ? (seconds + ' sec ') : (seconds + ' sec ');
            }

            return timeString;
        }

        $scope.stopExam = () => {

            let reqObj = {
                activity_id: $scope.activityId,
                qp_id: qpId
            }

            authService.callAPI(activityCons.API_STOP_EXAM, "POST", reqObj, function(response) {
                if (response.result != undefined) {
                    console.log("result : " + response.result)
                    getQPDetails()
                } else {
                    console.log("error : " + response.error)
                }
            })
        }
        $scope.viewReport = () => {
            // $state.go('attendeeList', {
            //     qpId: qpId
            // })
            $state.go("reportsMainCtrl", {
                prevParams: {
                    planId: null
                },
                qpId: $stateParams.qpId,
                isFromModule : noAuthMenuBar
            })
        }
        $scope.viewScores = () => {
            $state.go("reportsScoresCtrl", {
                qp_id: qpId
            })
        }
        let loadActivityStatus = () => {
            authService.callAPI(activityCons.API_GET_ANSWER_DETAILS + qpId + '/' + userId, "GET", {}, function(response) {
                if (response.result && response.result.data && response.result.data.details) {
                         console.log(response.result.data.details)
                    if(response.result.data.details.student_user_doc &&
                        response.result.data.details.student_user_doc.admission_number){
                        localStorageService.set("st_admission_number", response.result.data.details.student_user_doc.admission_number)
                    }
                    // $scope.admission_number

                    $scope.activityAttended = true
                } else {
                    console.log("error : " + response.error)
                }
            })
        }
        $scope.copyPwdToClipboard = function () {
            let id = 'answer_sheet_lock'
            let r = document.createRange();
            r.selectNode(document.getElementById(id));
            let str = ''
            let dom = document.getElementById(id)
            if(dom && dom.innerText){
                str = dom.innerText
            }
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(r);
            document.execCommand('copy');
            window.getSelection().removeAllRanges()
            toastr.success("Copied the password " + str);
        }
        function setAcdademicdata(){
            let fields = ['class', 'batch', 'subject', 'session', 'curriculum',
                    'academic_year']
            let obj = {}
            for(var r = 0; r < fields.length; r++){
                obj[fields[r]] = authoring[fields[r]]
            }
            return obj
        }
        $scope.updateParentVisibility = (activity) => {
            let obj = {
                school_id : localStorageService.get("school_id"),
                qp_id: $stateParams.qpId,
                is_visibleto_parents : activity.is_visibleto_parents,
                toastr : toastr
            }
            qpHandler.updateParentVisibility(authService, obj)
        }
    }
}

export default QpSummaryController
class approveRejectCommentsController {
    constructor($scope, $mdDialog, parentScope, _toApprove) {
        $scope.modal = {}
        $scope.modal['title'] = "Proceed"
        if(_toApprove){
            $scope.modal['title'] = "Are you sure to Approve?"
            $scope.modal['btn_text'] = "Approve"
        }else{
            $scope.modal['title'] = "Are you sure to Reject?"
            $scope.modal['btn_text'] = "Reject"
        }
        $scope.selections = {}
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.saveAction = () => {
            if(_toApprove){
                parentScope.approveFromPoppup($scope.selections['reason'])
            }else{
                parentScope.rejectFromPoppup($scope.selections['reason'])
            }
            $mdDialog.cancel();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/qpSummary.js